<section class="error-page White">
  <div class="grid-container">
    <h2>404 - Page Not Found</h2>
    <h4 class="subtext">The page you were looking for cannot be found or is no longer available. Please try searching again.</h4>
      <div class="button-container">
        <a tabindex="0" class="btn primary-button" [routerLink]="['/']">Return to Home</a>
      </div>
  </div>
</section>
